import { render, staticRenderFns } from "./CaseSection.vue?vue&type=template&id=b3cc8a10&scoped=true&"
import script from "./CaseSection.vue?vue&type=script&lang=js&"
export * from "./CaseSection.vue?vue&type=script&lang=js&"
import style0 from "./CaseSection.vue?vue&type=style&index=0&id=b3cc8a10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3cc8a10",
  null
  
)

export default component.exports